import { ISCEService } from "angular";
import { IEmptyState, IInfoBox } from "./models";
import { AnalyticsService } from "@gtmhub/core/analytics";
import { emptyStatesMap, getEmptyStateInfoBoxes } from "./empty-state-utils";

export class EmptyStateService {
  static $inject = ["$sce", "AnalyticsService"];

  constructor(private sceService: ISCEService, private analyticsService: AnalyticsService) {}

  getEmptyStateInfoBoxes(id: string): IInfoBox[] {
    const emptyStateInfoBoxes = getEmptyStateInfoBoxes(this.analyticsService)[id];

    if (!emptyStateInfoBoxes) {
      console.error(`Empty State info boxes with id: ${id}, not found.`);
    }

    return emptyStateInfoBoxes || [];
  }

  public getEmptyState(id: string): IEmptyState {
    const emptyState = emptyStatesMap()[id];

    if (!emptyState) {
      console.error(`Empty State with id: ${id}, not found.`);
    }

    return emptyState;
  }

  public trustResource(videoUrl: string): string {
    return this.sceService.trustAsResourceUrl(videoUrl);
  }
}
